import React from "react";
import { Stack } from "@mui/material";
import ClassificationForm from "./ClassificationForm";
import RevaText from "components/common/RevaText";
import { ROUTES } from "constants/routes";

const onSubmitResponse = (classification, props) => {
  console.log("classification is", classification);
  props.history.push(`${ROUTES.ADMIN.ORGANIZATIONS}/classifications`);
};

const CreateClassification = (props) => {
  return (
    <Stack>
      <RevaText variant="h2">Nuevo ranking</RevaText>
      <ClassificationForm onSubmitResponse={(classification) => onSubmitResponse(classification, props)} />
    </Stack>
  );
};

export default CreateClassification;
